import styled from "styled-components";

export const CintilloText = styled.p`
  margin: 0;
`;

export const InfoCintillo = styled.div`
  flex: 1;
  display: flex;
  justify-content: space-between;
  padding: 0 15px;
  min-height: 28px;
  align-items: center;
  span {
    font-weight: bold;
  }
`;
